import { Component, Input, OnInit } from '@angular/core';
import { BusinessCase, ZeroBusinessCase } from 'src/app/shared/models/businessCase';
import { Setting } from 'src/app/shared/models/settings.models';
import { BusinessCaseService } from '../../settings/business-case/business-case.service';
import { ToastMessageService } from 'src/app/toastr.service';

@Component({
  selector: 'app-business-case-setting',
  templateUrl: './business-case-setting.component.html',
  styleUrl: './business-case-setting.component.scss'
})
export class BusinessCaseSettingComponent implements OnInit {
  submolecules: any[];
  subMolecule = false;
  selectedSubMolecule: any;
  Molecule = false;
  DragData: any = {};
  noData = false;
  settings: Setting[];
  cols: any[];
  businessCase: BusinessCase[];
  zeroBusinessData: ZeroBusinessCase[];
  public columns: { header: Array<any>; data: Array<any> };
  settinglist: any;
  total = 0;
  total1 = 0;
  total2 = 0;
  total3 = 0;
  total4 = 0;
  total5 = 0;
  total6 = 0;
  total7 = 0;
  total8 = 0;
  total9 = 0;
  total10 = 0;
  private value;
  @Input() MolData: any;
  strength: any;
  growth: any;
  initialValues: any;
  marketShare: any;
  rld_price: unknown[];
  rld_strength: any;
  priceErosion_strength: any;
  priceErosion_fillVolume: any;
  launch_year: any;
  year_1: any;
  year_2: any;
  year_3: any;
  final_year: any;
  npvData: any;
  therapeuticClass: any;
  show = false;
  showIntialValue = false;
  showFutureFillVol = false;
  showGrowthFillVol = false;
  showMarketFillVol = false;
  showRLDFillVol = false;
  showLaunchFillVol = false;
  showCogsFillVol = false;
  showErosionFillVol = false;
  showMarketStrength = false;
  showMarketShare = false;
  showMarketYear1 = false;
  showMarketYear2 = false;
  showMarketYear3 = false;
  showMarketfinal = false;
  showRldstrength = false;
  showRldvalues = false;
  showPriceErosionStrength = false;
  showLaunchYear = false;
  showYear1 = false;
  showYear2 = false;
  showYear3 = false;
  showFinalYear = false;
  showMarketStrengthlaunch = false;
  Cogs: any;
  launch_year_market: any;
  showMarketLaunchYear = false;
  showCogsStrength = false;
  showFinalCogs = false;
  showApiDatabase = false;
  showOverhead = false;
  showRMPMBox5 = false;
  showTheraputicClass = false;
  apiPrice: any;
  peakYear: any;
  peakSalesInput: any;
  capex: any;
  peakSalesOutput: any;
  logistics: any;
  sga: any;
  Insurance: any;
  wacc: any;
  tax: any;
  expected_entrants: any;
  showApiPrice = false;
  showpeakYear = false;
  showCapex = false;
  showPeakSalesInput = false;
  showPeakSalesOutput = false;
  showLogistics = false;
  showSga = false;
  showWacc = false;
  showTax = false;
  showInsurance = false;
  showExpectedEntrance = false;
  showExpectedANDA = false;
  showExpectedTentative = false;
  showExpectedFiled = false;
  showExpectedEntrants = false;
  showExpectedAll = false;
  dataNA: any;
  businessData: any;
  @Input() needRefresh = false;
  firstTable: any;
  showGrowth = false;
  showGrowthStrength = false;
  final_val: any;
  total_players: any;
  launch_val: any;
  rate_decline: any;
  price_erosion_rld: any;
  yr2_val: any;
  yr3_val: any;
  yr4_val: any;
  paramsValues: any;
  email: any;
  isFillVolumeAvailable: any;
  isFillVolumeGrowth: any;
  isFillVolumeMarketShare: any;
  isFillVolumeRLD: any;
  isFillVolumePriceEro: any;
  isFillVolumeLaunchYear: any;
  isFillVolumeCogs: any;

  disable = false;

  @Input() callUserEmail!: any;

  constructor(
    private businessService: BusinessCaseService,
    private toastService: ToastMessageService,

  ) {
    this.submolecules = [];

    this.cols = [
      { field: "variable", header: "Variable" },
      { field: "value", header: "Value" },
    ];
  }

  ngOnInit(): void {
    this.email = localStorage.getItem("email");
    this.getFirstTableData();
    this.cumulativeRevenue();
    console.log("callUserEmail", this.callUserEmail);

  }

  getFirstTableData() {
    const MData = this.MolData;
    let moleculeData = {
      brand_name: MData.brand_name,
      nda: MData.nda_number,
      forecast_year: "2035",
      user_email: this.email,
      email: this.callUserEmail?.value,
    };
    // let moleculeData: any = {
    //   brand_name: MData[0],
    //   nda: MData[1],
    //   forecast_year: "2035",
    // };
    console.log("moleculeData", moleculeData)
    this.businessService.getUserBusinessCase(moleculeData).subscribe((resp) => {
      console.log("iewu", resp);
      this.firstTable = resp["custom_values"];
      if (resp === "N/A") {
        this.getBusinessCase_NA_DATA();
      } else {
        this.getBusinessCaseData();
      }
      this.strength = resp["custom_values"]["Future_Volume_Growth/Degrowth"]; //Future Volume Growth
      this.isFillVolumeAvailable = this.strength.some(item =>
        item.hasOwnProperty('Fill Volume/Weight (ml or gm)')
      )
      this.growth = resp["custom_values"]["Growth"]; //Growth
      this.isFillVolumeGrowth = this.growth.some(item =>
        item.hasOwnProperty('Fill Volume/Weight (ml or gm)')
      )
      this.marketShare = resp["custom_values"]["Market_Share_percent"]; //Market Share
      this.isFillVolumeMarketShare =
        Array.isArray(this.marketShare) && this.marketShare.some(item =>
          item.hasOwnProperty('Fill Volume/Weight (ml or gm)')
        );
      this.rld_price = resp["custom_values"]["RLD_Price_Increase"]; // RLD Price
      this.isFillVolumeRLD = this.rld_price.some(item =>
        item.hasOwnProperty('Fill Volume/Weight (ml or gm)')
      )
      // Price Erosion
      this.priceErosion_strength = resp["custom_values"]["Price_Erosion"];
      this.isFillVolumePriceEro =
        resp["custom_values"]["Price_Erosion"].hasOwnProperty('Fill Volume/Weight (ml or gm)') &&
        resp["custom_values"]["Price_Erosion"]["Fill Volume/Weight (ml or gm)"].length > 0;
      this.priceErosion_fillVolume = resp["custom_values"]["Price_Erosion"]["Fill Volume/Weight (ml or gm)"];
      this.launch_year = resp["custom_values"]["Price_Erosion"]?.launch_year;
      this.year_1 = resp["custom_values"]["Price_Erosion"]["year 1"];
      this.year_2 = resp["custom_values"]["Price_Erosion"]["year 2"];
      this.year_3 = resp["custom_values"]["Price_Erosion"]["year 3"];
      this.final_year = resp["custom_values"]["Price_Erosion"].final_year;
      this.total_players = resp["custom_values"]["Price_Erosion"].total_players;
      this.final_val = resp["custom_values"]["Price_Erosion"].final_val;
      this.launch_val = resp["custom_values"]["Price_Erosion"].launch_val;
      this.rate_decline =
        resp["custom_values"]["Price_Erosion"].rate_of_decline;
      this.price_erosion_rld =
        resp["custom_values"]["Price_Erosion"]["rld price"];
      this.yr2_val = resp["custom_values"]["Price_Erosion"].yr2_val;
      this.yr3_val = resp["custom_values"]["Price_Erosion"].yr3_val;
      this.yr4_val = resp["custom_values"]["Price_Erosion"].yr4_val;
      // this.launch_year_market = resp["custom_values"]["launch_year"];  // Hide in Dev
      this.therapeuticClass = resp["custom_values"]["Therapeutic_category"];
      this.Cogs = resp["custom_values"]["Cogs"];
      this.isFillVolumeCogs = this.Cogs.some(item =>
        item.hasOwnProperty('Fill Volume/Weight (ml or gm)')
      )
      this.apiPrice = resp["custom_values"]["API_Price_USD_PER_KG"];
      this.peakYear = resp["custom_values"]["Peak_Year"];
      this.capex = resp["custom_values"]["Capex"];
      this.peakSalesInput = resp["custom_values"]["Peak_Sales_Input"];
      this.peakSalesOutput = resp["custom_values"]["Peak_Sales_Output"];
      this.logistics = resp["custom_values"]["Logistics"];
      this.sga = resp["custom_values"]["SG_A"];
      this.Insurance = resp["custom_values"]["Insurance & Rebates"];
      this.wacc = resp["custom_values"]["WACC"];
      this.tax = resp["custom_values"]["Tax"];
      this.expected_entrants = resp["result"]["Expected_entrants"];
      this.launch_year_market = resp["result"]["Launch_year"];
      this.isFillVolumeLaunchYear = Array.isArray(this.launch_year_market) && this.launch_year_market.some(item =>
        item.hasOwnProperty('Fill Volume/Weight (ml or gm)')
      )
    },error => {
      console.log("error", error);
      this.toastService.error("Error fetching business case data");
    },() => {
      console.log("completed");
    });
  }

  getBusinessCaseData() {
    // const MData = this.MolData.split(",");
    // let moleculeData: any = {
    //   brand_name: MData[0],
    //   nda: MData[1],
    // };
    const MData = this.MolData;
    let moleculeData = {
      brand_name: MData.brand_name,
      nda: MData.nda_number,
      user_email: this.email,
      email: this.callUserEmail?.value,
    };
    this.businessService
      .getUserBusinessCase(moleculeData)
      .subscribe((data: any) => {
        this.businessCase = data;
        this.npvData = data.result;
        this.organizeTheData(data);
        this.findsum(this.businessCase);
      });
  }

  getBusinessCase_NA_DATA() {
    // const MData = this.MolData.split(",");
    // let moleculeData: any = {
    //   brand_name: MData[0],
    //   nda: MData[1],
    // };
    const MData = this.MolData;
    let moleculeData = {
      brand_name: MData.brand_name,
      nda: MData.nda_number,
      user_email: this.email,
      email: this.callUserEmail?.value,
    };
    this.businessService
      .getUserBusinessCase(moleculeData)
      .subscribe((data: any) => {
        let businessData: any = {
          nda_number: MData[1],
          data: data.data,
        };
        this.businessService
          .getBusinessCase_NA_Data(businessData)
          .subscribe((data: any) => {
            this.zeroBusinessData = data;
          });
      });
  }
  private organizeTheData(business) {
    const header = [];
    const data = [];
    business.data.forEach((row: any) => {
      header.push(row.year);
      data.push(row);
    });
    this.columns = { header, data };
  }

  findsum(data) {
    this.value = data;
    for (let j = 0; j < data.length; j++) {
      this.total += this.value[j].Revenue;
      this.total1 += this.value[j].COGs;
      this.total2 += this.value[j].GM;
      this.total3 += this.value[j].OPEX;
      this.total4 += this.value[j].EBITDA;
      this.total5 += this.value[j].Insurance;
      this.total6 += this.value[j].Logistics;
      this.total7 += this.value[j].NetTax;
      this.total8 += this.value[j].PAT;
      this.total9 += this.value[j].PBT;
      this.total10 += this.value[j].SGA;
    }
  }

  getSetting() {
    this.businessService.getSettings().then((data) => (this.settings = data));
  }

  onClickEdit() {
    // this.show = !this.show;   // Hide in Dev
    this.showIntialValue = !this.showIntialValue;
    // this.showFutureFillVol = !this.showFutureFillVol;     // Hide in Dev
    // this.showGrowthStrength = !this.showGrowthStrength;   // Hide in Dev
    this.showGrowth = !this.showGrowth;
    // this.showMarketStrength = !this.showMarketStrength;   // Hide in Dev
    this.showMarketShare = !this.showMarketShare;
    this.showMarketYear1 = !this.showMarketYear1;
    this.showMarketYear2 = !this.showMarketYear2;
    this.showMarketYear3 = !this.showMarketYear3;
    this.showMarketfinal = !this.showMarketfinal;
    this.showRldstrength = !this.showRldstrength;
    this.showRldvalues = !this.showRldvalues;
    // this.showPriceErosionStrength = !this.showPriceErosionStrength;   // Hide in Dev
    this.showLaunchYear = !this.showLaunchYear;
    // this.showMarketStrengthlaunch = !this.showMarketStrengthlaunch;   // Hide in Dev
    this.showYear1 = !this.showYear1;
    this.showYear2 = !this.showYear2;
    this.showYear3 = !this.showYear3;
    this.showFinalYear = !this.showFinalYear;
    this.showMarketLaunchYear = !this.showMarketLaunchYear;
    // this.showCogsStrength = !this.showCogsStrength;    // Hide in Dev
    this.showFinalCogs = !this.showFinalCogs;
    // this.showApiDatabase = !this.showApiDatabase;      // Hide in Dev
    this.showOverhead = !this.showOverhead;
    this.showRMPMBox5 = !this.showRMPMBox5;
    this.showTheraputicClass = !this.showTheraputicClass;
    this.showInsurance = !this.showInsurance;
    this.showApiPrice = !this.showApiPrice;
    this.showpeakYear = !this.showpeakYear;
    this.showCapex = !this.showCapex;
    this.showPeakSalesInput = !this.showPeakSalesInput;
    this.showPeakSalesOutput = !this.showPeakSalesOutput;
    this.showLogistics = !this.showLogistics;
    this.showSga = !this.showSga;
    this.showWacc = !this.showWacc;
    this.showTax = !this.showTax;
    // this.showExpectedEntrance = !this.showExpectedEntrance;
    // this.showExpectedANDA = !this.showExpectedANDA;
    // this.showExpectedTentative = !this.showExpectedTentative;
    // this.showExpectedFiled = !this.showExpectedFiled;
    // this.showExpectedEntrants = !this.showExpectedEntrants;
    // this.showExpectedAll = !this.showExpectedAll;
    this.disable = !this.disable;
  }

  cumulativeRevenue() {
    const revenueData = this.MolData;
    let moleculeData = {
      brand_name: revenueData.brand_name,
      nda_number: revenueData.nda_number,
      user_email: this.email,
    };
    // let nda_numbermoleculeData: any = {
    //   brand_name: revenueData[0],
    //   nda_number: revenueData[1],
    // };
    this.businessService
      .getCumulativeRevenue(moleculeData)
      .subscribe((res: any) => { });
  }

  editedBusinessCaseData() {
    const editedData = this.MolData;
    // Hide in Dev
    // if (
    //   this.priceErosion_strength?.Strength &&
    //   this.priceErosion_strength?.Strength.length > 0
    // ) {
    //   var newValue = [];
    //   this.priceErosion_strength?.Strength.forEach((element, index) => {
    //     let newFind = (<HTMLInputElement>(
    //       document.getElementById("priceErosion_strength_Strength_" + index)
    //     )).value
    //       ? (<HTMLInputElement>(
    //         document.getElementById("priceErosion_strength_Strength_" + index)
    //       )).value
    //       : element;
    //     newValue.push(newFind);
    //   });
    //   this.priceErosion_strength.Strength = newValue;
    // }
    // if (
    //   this.priceErosion_fillVolume &&
    //   this.priceErosion_fillVolume.length > 0
    // ) {
    //   var newValue = [];
    //   this.priceErosion_fillVolume.forEach((element, index) => {
    //     let newFind = (<HTMLInputElement>(
    //       document.getElementById("priceErosion_fill_Vol_" + index)
    //     )).value
    //       ? (<HTMLInputElement>(
    //         document.getElementById("priceErosion_fill_Vol_" + index)
    //       )).value
    //       : element;
    //     newValue.push(newFind);
    //   });
    //   this.priceErosion_strength["Fill Volume/Weight (ml or gm)"] = newValue;
    // }
    if (this.launch_year && this.launch_year.length > 0) {
      var newValue = [];
      this.launch_year.forEach((element, index) => {
        let newFind = (<HTMLInputElement>(
          document.getElementById("launch_year_" + index)
        )).value
          ? (<HTMLInputElement>document.getElementById("launch_year_" + index))
            .value
          : element;

        newValue.push(Number(newFind));
      });

      this.priceErosion_strength["launch_year"] = newValue;
    }
    if (this.year_1 && this.year_1.length > 0) {
      var newValue = [];
      this.year_1.forEach((element, index) => {
        let newFind = (<HTMLInputElement>(
          document.getElementById("year_1_" + index)
        )).value
          ? (<HTMLInputElement>document.getElementById("year_1_" + index)).value
          : element;
        newValue.push(Number(newFind));
      });
      this.priceErosion_strength["year 1"] = newValue;
    }
    if (this.year_2 && this.year_2.length > 0) {
      var newValue = [];
      this.year_2.forEach((element, index) => {
        let newFind = (<HTMLInputElement>(
          document.getElementById("year_2_" + index)
        )).value
          ? (<HTMLInputElement>document.getElementById("year_2_" + index)).value
          : element;
        newValue.push(Number(newFind));
      });
      this.priceErosion_strength["year 2"] = newValue;
    }
    if (this.year_3 && this.year_3.length > 0) {
      var newValue = [];
      this.year_3.forEach((element, index) => {
        let newFind = (<HTMLInputElement>(
          document.getElementById("year_3_" + index)
        )).value
          ? (<HTMLInputElement>document.getElementById("year_3_" + index)).value
          : element;
        newValue.push(Number(newFind));
      });
      this.priceErosion_strength["year 3"] = newValue;
    }
    if (this.final_year && this.final_year.length > 0) {
      var newValue = [];
      this.final_year.forEach((element, index) => {
        let newFind = (<HTMLInputElement>(
          document.getElementById("final_year_" + index)
        )).value
          ? (<HTMLInputElement>document.getElementById("final_year_" + index))
            .value
          : element;
        newValue.push(Number(newFind));
      });
      this.priceErosion_strength["final_year"] = newValue;
    }

    let moleculeData: any = {
      brand_name: editedData.brand_name,
      nda: editedData.nda_number,
      email: this.callUserEmail?.value,
      user_email: this.email,
      payload: {
        custom_values: {
          "Future_Volume_Growth/Degrowth": this.strength,
          Growth: this.growth,
          Market_Share_percent: this.marketShare,
          RLD_Price_Increase: this.rld_price,
          Price_Erosion: this.priceErosion_strength,
          // launch_year: this.launch_year_market,  // Hide in Dev
          Therapeutic_category: this.therapeuticClass,
          Cogs: this.Cogs,
          API_Price_USD_PER_KG: this.apiPrice,
          Peak_Year: this.peakYear,
          Capex: this.capex,
          Peak_Sales_Input: this.peakSalesInput,
          Peak_Sales_Output: this.peakSalesOutput,
          Logistics: this.logistics,
          "Insurance & Rebates": this.Insurance,
          SG_A: this.sga,
          WACC: this.wacc,
          Tax: this.tax,
        },
        result: {
          ...this.npvData, // Unhide in dev
          // ExpectedEntrants: this.expected_entrants,
          // Launch_year: this.launch_year_market,
        }
      },
    };
    console.log("moleculeData========", moleculeData);
    this.businessService
      .updateUserBusinessCaseData(moleculeData)
      .subscribe((res: any) => {
        this.onClickEdit();
        this.strength = res["custom_values"]["Future_Volume_Growth/Degrowth"]; //Future Volume Growth
        this.growth = res["custom_values"]["Growth"]; //Growth
        this.marketShare = res["custom_values"]["Market_Share_percent"]; //Market Share
        this.rld_price = res["custom_values"]["RLD_Price_Increase"]; // RLD Price
        // Price Erosion
        this.priceErosion_strength = res["custom_values"]["Price_Erosion"];
        this.priceErosion_fillVolume = res["custom_values"]["Price_Erosion"]["Fill Volume/Weight (ml or gm)"];
        this.launch_year = res["custom_values"]["Price_Erosion"]?.launch_year;
        this.year_1 = res["custom_values"]["Price_Erosion"]["year 1"];
        this.year_2 = res["custom_values"]["Price_Erosion"]["year 2"];
        this.year_3 = res["custom_values"]["Price_Erosion"]["year 3"];
        this.final_year = res["custom_values"]["Price_Erosion"].final_year;
        this.total_players =
          res["custom_values"]["Price_Erosion"].total_players;
        this.final_val = res["custom_values"]["Price_Erosion"].final_val;
        this.launch_val = res["custom_values"]["Price_Erosion"].launch_val;
        this.rate_decline =
          res["custom_values"]["Price_Erosion"].rate_of_decline;
        this.price_erosion_rld =
          res["custom_values"]["Price_Erosion"]["rld price"];
        this.yr2_val = res["custom_values"]["Price_Erosion"].yr2_val;
        this.yr3_val = res["custom_values"]["Price_Erosion"].yr3_val;
        this.yr4_val = res["custom_values"]["Price_Erosion"].yr4_val;
        // this.launch_year_market = res["custom_values"]["launch_year"];  // Hide in Dev
        this.therapeuticClass = res["custom_values"]["Therapeutic_category"];
        this.Cogs = res["custom_values"]["Cogs"];
        this.apiPrice = res["custom_values"]["API_Price_USD_PER_KG"];
        this.peakYear = res["custom_values"]["Peak_Year"];
        this.capex = res["custom_values"]["Capex"];
        this.peakSalesInput = res["custom_values"]["Peak_Sales_Input"];
        this.peakSalesOutput = res["custom_values"]["Peak_Sales_Output"];
        this.logistics = res["custom_values"]["Logistics"];
        this.sga = res["custom_values"]["SG_A"];
        this.Insurance = res["custom_values"]["Insurance & Rebates"];
        this.wacc = res["custom_values"]["WACC"];
        this.tax = res["custom_values"]["Tax"];
        this.expected_entrants = res["result"].Expected_entrants;
        this.launch_year_market = res["result"].Launch_year;
        this.businessCase = res;
        this.organizeTheData(res);
        this.findsum(this.businessCase);
        this.npvData = res.result;
        if (res.message === "successful") {
          this.cumulativeRevenue();
        }
      });
  }

  refreshData() {
    // const MData = this.MolData.split(",");
    // let moleculeData: any = {
    //   brand_name: MData[0],
    //   nda: MData[1],
    // };

    const MData = this.MolData;
    let moleculeData = {
      brand_name: MData.brand_name,
      nda: MData.nda_number,
      user_email: this.email
    };

    this.businessService
      .refreshData(moleculeData)
      .subscribe((refreshData: any) => {
        this.strength =
          refreshData["custom_values"]["Future_Volume_Growth/Degrowth"]; //Future Volume Growth
        this.growth = refreshData["custom_values"]["Growth"]; //Growth
        this.marketShare = refreshData["custom_values"]["Market_Share_percent"]; //Market Share
        this.rld_price = refreshData["custom_values"]["RLD_Price_Increase"]; // RLD Price
        // Price Erosion
        this.priceErosion_strength =
          refreshData["custom_values"]["Price_Erosion"];
        this.priceErosion_fillVolume = refreshData["custom_values"]["Price_Erosion"]["Fill Volume/Weight (ml or gm)"];
        this.launch_year =
          refreshData["custom_values"]["Price_Erosion"]?.launch_year;
        this.year_1 = refreshData["custom_values"]["Price_Erosion"]["year 1"];
        this.year_2 = refreshData["custom_values"]["Price_Erosion"]["year 2"];
        this.year_3 = refreshData["custom_values"]["Price_Erosion"]["year 3"];
        this.final_year =
          refreshData["custom_values"]["Price_Erosion"].final_year;
        this.total_players =
          refreshData["custom_values"]["Price_Erosion"].total_players;
        this.final_val =
          refreshData["custom_values"]["Price_Erosion"].final_val;
        this.launch_val =
          refreshData["custom_values"]["Price_Erosion"].launch_val;
        this.rate_decline =
          refreshData["custom_values"]["Price_Erosion"].rate_of_decline;
        this.price_erosion_rld =
          refreshData["custom_values"]["Price_Erosion"]["rld price"];
        this.yr2_val = refreshData["custom_values"]["Price_Erosion"].yr2_val;
        this.yr3_val = refreshData["custom_values"]["Price_Erosion"].yr3_val;
        this.yr4_val = refreshData["custom_values"]["Price_Erosion"].yr4_val;
        // this.launch_year_market = refreshData["custom_values"]["launch_year"]; // Hide in Dev
        this.therapeuticClass =
          refreshData["custom_values"]["Therapeutic_category"];
        this.Cogs = refreshData["custom_values"]["Cogs"];
        this.apiPrice = refreshData["custom_values"]["API_Price_USD_PER_KG"];
        this.peakYear = refreshData["custom_values"]["Peak_Year"];
        this.capex = refreshData["custom_values"]["Capex"];
        this.peakSalesInput = refreshData["custom_values"]["Peak_Sales_Input"];
        this.peakSalesOutput =
          refreshData["custom_values"]["Peak_Sales_Output"];
        this.logistics = refreshData["custom_values"]["Logistics"];
        this.sga = refreshData["custom_values"]["SG_A"];
        this.Insurance = refreshData["custom_values"]["Insurance & Rebates"];
        this.wacc = refreshData["custom_values"]["WACC"];
        this.tax = refreshData["custom_values"]["Tax"];
        this.expected_entrants = refreshData["result"].Expected_entrants;
        this.launch_year_market = refreshData["result"].Launch_year;
        this.businessCase = refreshData;
        this.organizeTheData(refreshData);
        this.findsum(this.businessCase);
        this.npvData = refreshData.result;
        if (refreshData.message === "successful") {
          this.cumulativeRevenue();
        }
      });
  }
}
